import React from 'react';
import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { IUseDateDisplayOptions, useDateDisplay } from '../../hooks/useDateDisplay/useDateDisplay';
import { IColoursCollection } from '../../fundamentals/colours/colourInterfaces';
import { ITextProps, P } from '../Texts/Texts';

export const dateDisplayColours = ({ palette }: IColoursCollection) => ({
  dateDisplay: {
    text: palette.neutral
  }
});

export interface IDateDisplayProps extends ITextProps {
  date: Date;
  options?: IUseDateDisplayOptions;
}

const DateDisplayContainer = styled(P)`
  color: ${({ theme }) => theme.dateDisplay.text};
`;

export const DateDisplay: React.FC<IDateDisplayProps> = styled(({ date, options, ...rest }: IDateDisplayProps) => {
  const { generateTestId } = useTestId(rest, 'DateDisplay');
  const { formatDate } = useDateDisplay(options);

  return (
    <DateDisplayContainer gutter={false} {...generateTestId()} {...rest}>
      {formatDate(date)}
    </DateDisplayContainer>
  );
})``;
